import { Task } from 'taskarian';
import UserGroupMembershipsStore from '..';
import { callApi } from '../../../../../../../../Appy';
import { findLinkT } from '../../../../../../../../LinkyLinky';
import { Link } from '../../../../../../../../Resource/Types';
import { fromNullableT } from '../../../../../../../../TaskExt';
import { bulkGroupMembershipsResourceDecoder } from '../Decoders';
import { userGroupMembershipsEncoder } from '../Encoders';
import { Creating, UserGroupMembershipsError } from '../Types';

const createUserGroupMemberships = (store: UserGroupMembershipsStore, state: Creating) =>
  Task.succeed<UserGroupMembershipsError, ReadonlyArray<Link>>(store.links)
    .andThen(findLinkT('create'))
    .andThen(
      callApi(bulkGroupMembershipsResourceDecoder, userGroupMembershipsEncoder(store, state)),
    );

const getErrorType =
  (store: UserGroupMembershipsStore, state: Creating) =>
  (error: UserGroupMembershipsError): Task<UserGroupMembershipsError, void> =>
    fromNullableT(state.userGroupMembershipsFormResource.templates.self).map((template) =>
      store.newFormSubmissionError(state.userGroupMembershipsFormResource, error, template),
    );

export const create = (store: UserGroupMembershipsStore, state: Creating) =>
  createUserGroupMemberships(store, state).fork(getErrorType(store, state), store.succeeded);
